var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path, _path2, _path3, _rect, _path4, _g23, _path5, _g24, _polygon, _g25, _path6, _g26, _polygon2, _g27, _path7, _g28, _polygon3, _g29, _path8, _g30, _polygon4, _g31, _path9, _g32, _polygon5, _g33, _polygon6, _g34, _polygon7, _g35, _path10, _g36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1159.9 357.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#Degradado_sin_nombre_10);}.cls-3{fill:url(#Degradado_sin_nombre_10-2);}.cls-4{fill:url(#Degradado_sin_nombre_10-3);}.cls-5{fill:url(#Degradado_sin_nombre_10-4);}.cls-6{fill:url(#Degradado_sin_nombre_10-5);}.cls-7{fill:url(#Degradado_sin_nombre_10-6);}.cls-8{fill:url(#Degradado_sin_nombre_10-7);}.cls-9{fill:url(#Degradado_sin_nombre_10-8);}.cls-10{fill:url(#Degradado_sin_nombre_10-9);}.cls-11{fill:url(#Degradado_sin_nombre_10-10);}.cls-12{fill:url(#Degradado_sin_nombre_10-11);}.cls-13{fill:url(#Degradado_sin_nombre_10-12);}.cls-14{fill:url(#Degradado_sin_nombre_10-13);}.cls-15{fill:url(#Degradado_sin_nombre_10-14);}.cls-16{clip-path:url(#clip-path);}.cls-17{clip-path:url(#clip-path-2);}.cls-18{clip-path:url(#clip-path-3);}.cls-19{clip-path:url(#clip-path-4);}.cls-20{clip-path:url(#clip-path-5);}.cls-21{clip-path:url(#clip-path-6);}.cls-22{clip-path:url(#clip-path-7);}.cls-23{clip-path:url(#clip-path-8);}.cls-24{clip-path:url(#clip-path-9);}.cls-25{clip-path:url(#clip-path-10);}.cls-26{clip-path:url(#clip-path-11);}.cls-27{clip-path:url(#clip-path-12);}.cls-28{clip-path:url(#clip-path-13);}.cls-29{clip-path:url(#clip-path-14);}.cls-30{clip-path:url(#clip-path-15);}.cls-31{clip-path:url(#clip-path-16);}.cls-32{clip-path:url(#clip-path-17);}.cls-33{clip-path:url(#clip-path-18);}.cls-34{clip-path:url(#clip-path-19);}.cls-35{clip-path:url(#clip-path-20);}.cls-36{clip-path:url(#clip-path-21);}.cls-37{clip-path:url(#clip-path-22);}.cls-38{clip-path:url(#clip-path-23);}.cls-39{fill:#fff;}.cls-40{clip-path:url(#clip-path-24);}.cls-41{clip-path:url(#clip-path-26);}.cls-42{clip-path:url(#clip-path-28);}.cls-43{clip-path:url(#clip-path-30);}.cls-44{clip-path:url(#clip-path-32);}.cls-45{clip-path:url(#clip-path-33);}.cls-46{clip-path:url(#clip-path-35);}.cls-47{clip-path:url(#clip-path-37);}.cls-48{clip-path:url(#clip-path-38);}.cls-49{clip-path:url(#clip-path-39);}.cls-50{clip-path:url(#clip-path-41);}.cls-51{clip-path:url(#clip-path-43);}.cls-52{clip-path:url(#clip-path-45);}.cls-53{clip-path:url(#clip-path-47);}.cls-54{clip-path:url(#clip-path-49);}.cls-55{clip-path:url(#clip-path-51);}.cls-56{clip-path:url(#clip-path-52);}.cls-57{clip-path:url(#clip-path-53);}.cls-58{clip-path:url(#clip-path-55);}.cls-59{clip-path:url(#clip-path-57);}.cls-60{clip-path:url(#clip-path-59);}.cls-61{clip-path:url(#clip-path-61);}.cls-62{clip-path:url(#clip-path-62);}.cls-63{clip-path:url(#clip-path-63);}.cls-64{clip-path:url(#clip-path-65);}.cls-65{fill:url(#Degradado_sin_nombre_10-16);}.cls-66{clip-path:url(#clip-path-66);}.cls-67{clip-path:url(#clip-path-67);}.cls-68{clip-path:url(#clip-path-68);}.cls-69{clip-path:url(#clip-path-69);}.cls-70{clip-path:url(#clip-path-70);}.cls-71{clip-path:url(#clip-path-71);}.cls-72{clip-path:url(#clip-path-72);}.cls-73{fill:url(#Degradado_sin_nombre_10-30);}.cls-74{clip-path:url(#clip-path-73);}.cls-75{clip-path:url(#clip-path-74);}.cls-76{clip-path:url(#clip-path-75);}.cls-77{clip-path:url(#clip-path-76);}.cls-78{clip-path:url(#clip-path-77);}.cls-79{clip-path:url(#clip-path-78);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: 741.16,
    y1: -288.13,
    x2: 804.6,
    y2: -288.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#083472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-2",
    x1: 806.39,
    y1: -288.13,
    x2: 861.52,
    y2: -288.13,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-3",
    x1: 864.68,
    y1: -288.13,
    x2: 915.6,
    y2: -288.13,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-4",
    x1: 921.08,
    y1: -288.13,
    x2: 968.06,
    y2: -288.13,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-5",
    x1: 978.94,
    y1: -288.13,
    x2: 1058.5,
    y2: -288.13,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-6",
    x1: 1066.8,
    y1: -288.13,
    x2: 1121.93,
    y2: -288.13,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-7",
    x1: 684.33,
    y1: -379.6,
    x2: 739.46,
    y2: -379.6,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-8",
    x1: 745.37,
    y1: -379.6,
    x2: 804.86,
    y2: -379.6,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-9",
    x1: 812.66,
    y1: -379.6,
    x2: 856.63,
    y2: -379.6,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-10",
    x1: 863.22,
    y1: -379.34,
    x2: 918.61,
    y2: -379.34,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-11",
    x1: 924,
    y1: -379.6,
    x2: 974.92,
    y2: -379.6,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-12",
    x1: 1005.51,
    y1: -379.6,
    x2: 1065.01,
    y2: -379.6,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-13",
    x1: 1073.06,
    y1: -379.6,
    x2: 1137.27,
    y2: -379.6,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-14",
    x1: 684.33,
    y1: -288.13,
    x2: 739.46,
    y2: -288.13,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-679.15,303.77c0,10.4,5.22,10.35,14.18,11l2.13,0.15c4.55,0.29,5.08.24,5.08,3.39s-1.5,3.34-6.05,3.34c-4.74,0-6.1-.39-6.1-4.16h-9.29c0,11.9,6.15,12.1,15.39,12.1,16,0,15.73-5.9,15.73-11.91,0-8.32-2.66-9.68-13.4-10.45l-4-.29c-2.56-.2-4-0.29-4-3.19,0-2,.43-3.1,5.66-3.1,3.87,0,5.42,0,5.42,3.73h9.29v-1.5c0-10-6.78-10.16-14.71-10.16-9.48,0-15.34.68-15.34,11.08"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-634.79,315.19V307c0.14-5.37,1.79-5.9,6.82-5.9s6.82,0.53,6.82,5.9v8.18c0,5.42-1.79,6-6.82,6s-6.68-.54-6.82-6m-10-9.19v10.26c0,11.18,7,13.31,16.79,13.31s16.79-2.13,16.79-13.31V306c0-11.18-7-13.31-16.79-13.31s-16.79,2.13-16.79,13.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "-606.77 292.98 -606.77 329.27 -581.96 329.27 -581.96 320.85 -597.1 320.85 -597.1 292.98 -606.77 292.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-556.65,293v23.56c0,4.26-1.4,4.6-5.52,4.6s-6.39-.05-6.39-4.16V293h-9.68v24.19c0,8.71,1.55,12.39,16.07,12.39,10.65,0,15.19-2.71,15.19-12.39V293h-9.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "-543.93 292.98 -543.93 301.4 -534.64 301.4 -534.64 329.27 -524.97 329.27 -524.97 301.4 -515.19 301.4 -515.19 292.98 -543.93 292.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-488,315.19V307c0.14-5.37,1.79-5.9,6.82-5.9s6.82,0.53,6.82,5.9v8.18c0,5.42-1.79,6-6.82,6s-6.68-.54-6.82-6m-10-9.19v10.26c0,11.18,7,13.31,16.79,13.31s16.79-2.13,16.79-13.31V306c0-11.18-7-13.31-16.79-13.31s-16.79,2.13-16.79,13.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "-433.23 292.98 -432.65 320.85 -433.04 320.85 -443.44 292.98 -459.8 292.98 -459.8 329.27 -450.12 329.27 -450.7 301.4 -450.31 301.4 -440.06 329.27 -423.56 329.27 -423.56 292.98 -433.23 292.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-400.28,303.77c0,10.4,5.23,10.35,14.18,11l2.13,0.15c4.55,0.29,5.08.24,5.08,3.39s-1.5,3.34-6.05,3.34c-4.74,0-6.1-.39-6.1-4.16h-9.29c0,11.9,6.15,12.1,15.39,12.1,16,0,15.73-5.9,15.73-11.91,0-8.32-2.67-9.68-13.4-10.45l-4-.29c-2.56-.2-4-0.29-4-3.19,0-2,.43-3.1,5.66-3.1,3.87,0,5.42,0,5.42,3.73h9.29v-1.5c0-10-6.77-10.16-14.71-10.16-9.48,0-15.34.68-15.34,11.08"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "-343.67 292.98 -350.35 306.96 -350.68 306.96 -357.17 292.98 -368.25 292.98 -355.38 316.54 -355.38 329.27 -345.7 329.27 -345.7 316.54 -332.44 292.98 -343.67 292.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-331.38,303.77c0,10.4,5.23,10.35,14.18,11l2.13,0.15c4.55,0.29,5.08.24,5.08,3.39s-1.5,3.34-6,3.34c-4.74,0-6.1-.39-6.1-4.16h-9.29c0,11.9,6.14,12.1,15.39,12.1,16,0,15.72-5.9,15.72-11.91,0-8.32-2.66-9.68-13.4-10.45l-4-.29c-2.56-.2-4-0.29-4-3.19,0-2,.43-3.1,5.66-3.1,3.87,0,5.42,0,5.42,3.73h9.29v-1.5c0-10-6.77-10.16-14.71-10.16-9.49,0-15.34.68-15.34,11.08"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "-298.53 292.98 -298.53 301.4 -289.24 301.4 -289.24 329.27 -279.57 329.27 -279.57 301.4 -269.79 301.4 -269.79 292.98 -298.53 292.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "-266.7 292.98 -266.7 329.27 -240.18 329.27 -240.18 321.33 -257.02 321.33 -257.02 314.27 -241.54 314.27 -241.54 307.54 -257.02 307.54 -257.02 300.91 -240.52 300.91 -240.52 292.98 -266.7 292.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "-204.86 292.98 -211.44 315.77 -211.78 315.77 -218.7 292.98 -234.04 292.98 -234.04 329.27 -224.36 329.27 -225.33 301.44 -225.04 301.44 -215.75 329.27 -207.38 329.27 -198.19 301.44 -197.85 301.44 -198.81 329.27 -189.14 329.27 -189.14 292.98 -204.86 292.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-184.4,303.77c0,10.4,5.22,10.35,14.18,11l2.13,0.15c4.55,0.29,5.08.24,5.08,3.39s-1.5,3.34-6.05,3.34c-4.74,0-6.1-.39-6.1-4.16h-9.29c0,11.9,6.15,12.1,15.39,12.1,16,0,15.73-5.9,15.73-11.91,0-8.32-2.66-9.68-13.4-10.45l-4-.29c-2.56-.2-4-0.29-4-3.19,0-2,.43-3.1,5.66-3.1,3.87,0,5.42,0,5.42,3.73h9.29v-1.5c0-10-6.77-10.16-14.71-10.16-9.48,0-15.34.68-15.34,11.08"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-423.68,228.08a38.39,38.39,0,0,1-15.62-3.55v11.33H-477c-2.2,0-5.67,1.67-5.67,3.87V271c0,2.2,3.46,3.18,5.67,3.18h104.82c2.2,0,5.45-.61,5.45-2.81V240.11c0-2.2-3.25-4.24-5.45-4.24h-35.89V224.54a38.38,38.38,0,0,1-15.62,3.55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-462.15,108.65a5.56,5.56,0,0,1,5.68-5.42,5.56,5.56,0,0,1,5.68,5.42,5.56,5.56,0,0,1-5.68,5.42,5.56,5.56,0,0,1-5.68-5.42m-8.78,0a14.73,14.73,0,0,0,14.47,14.94A14.73,14.73,0,0,0-442,108.65,14.73,14.73,0,0,0-456.46,93.7a14.73,14.73,0,0,0-14.47,14.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-396.57,108.65a5.56,5.56,0,0,1,5.68-5.42,5.56,5.56,0,0,1,5.68,5.42,5.56,5.56,0,0,1-5.68,5.42,5.56,5.56,0,0,1-5.68-5.42m-8.78,0a14.73,14.73,0,0,0,14.47,14.94,14.73,14.73,0,0,0,14.47-14.94A14.73,14.73,0,0,0-390.89,93.7a14.73,14.73,0,0,0-14.47,14.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-437.45,195.69c0-6.56,5.73-11.89,12.77-11.89s12.77,5.33,12.77,11.89-5.73,11.89-12.77,11.89-12.77-5.33-12.77-11.89m-16.41,0A29.29,29.29,0,0,0-424.68,225a29.29,29.29,0,0,0,29.18-29.34,29.29,29.29,0,0,0-29.18-29.33,29.29,29.29,0,0,0-29.18,29.33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-374.43,28.19H-477c-2.2,0-5.67,1.52-5.67,3.72V63.17c0,2.2,3.46,3.33,5.67,3.33h37.69V166.84a38.36,38.36,0,0,1,15.62-3.55,38.35,38.35,0,0,1,15.62,3.55V66.5h35.89c2.2,0,5.45-.76,5.45-3V32.28c0-2.2-3.25-4.09-5.45-4.09h-2.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-681.9,30.19V166.77l-26.21,28.33c-0.13.15-.51,0.29-0.64,0.44-1.55,1.74-.82,4.53.84,6.16l26,22.68v44.85c0,2.12,1.28,4.16,3.41,4.16h30.12c2.12,0,2.72-2,2.72-4.16V187.09c10.66-13.25,24.08-26.5,35.9-39.76,1.46-1.64,3.14-3.27,4.6-4.9l5.53-6.08,20.43-22.85c0.34-.38.71-0.77,1.06-1.15l59.93-67.2c4.58-5.14,9.17-9.32,13.75-14.45,0.85-1,1.16-.37,1-2.5H-556c-15.34,17.06-30.69,33.46-46,50.66-1.46,1.63-2.91,2.79-4.37,4.42l-3.19,3.33-18.09,20.17c-1.85,2.07-4.15,4.09-6,6.16-3.85,4.32-9.87,8.58-12,12.9V30.19c0-2.12-.94-2-3.07-2h-30.74c-1.68,0-2.44.1-2.44,2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-600.22,153.54l-14.8,16.6c-2.13,2.4-4.59,4.71-3.17,8.13,1,2.35,3.58,4,5.41,5.58l9.23,8.23,31.64,28.21,43.59,38.86c4.43,4,8.84,8.14,13.29,12.07,1.77,1.56,3.64,2.75,5.62,2.75h8.64a1.47,1.47,0,0,0,1-1.13s0.29-44.23.29-44.25a4.83,4.83,0,0,0-.32-1.75,3.58,3.58,0,0,0-.93-1.35l-0.17-.16-1.24-1.1-1.5-1.33-1.27-1.13-0.52-.46c-2.34-1.92-4.56-4-6.81-6.06l-15.58-13.89-2.32-2.06-31.6-28.14-15.66-14-7.71-6.86c-1.53-1.36-3-3.14-5.14-3.59a5.67,5.67,0,0,0-1.16-.12c-3.88,0-6.42,4.3-8.75,6.91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M688.93,120.11c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H688.84c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.61,0,9.61,6.6h16.46v-2.66c0-17.74-12-18-26.07-18-16.8,0-27.17,1.2-27.17,19.64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -67.68,
    y: -1508.78,
    width: 4820.14,
    height: 3108.92
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M767.53,140.34V125.85c0.26-9.52,3.17-10.46,12.09-10.46s12.08,0.94,12.08,10.46v14.49c0,9.6-3.17,10.55-12.08,10.55s-11.83-.95-12.09-10.55m-17.66-16.29v18.17c0,19.81,12.34,23.58,29.75,23.58s29.75-3.77,29.75-23.58V124.05c0-19.81-12.35-23.58-29.75-23.58s-29.75,3.77-29.75,23.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "817.16 100.99 817.16 165.29 861.14 165.29 861.14 150.37 834.31 150.37 834.31 100.99 817.16 100.99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M906,101v41.75c0,7.54-2.49,8.15-9.77,8.15s-11.32-.09-11.32-7.38V101H867.73v42.86c0,15.44,2.75,21.95,28.47,21.95,18.86,0,26.92-4.8,26.92-21.95V101H906Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "928.51 100.99 928.51 115.91 944.97 115.91 944.97 165.29 962.11 165.29 962.11 115.91 979.43 115.91 979.43 100.99 928.51 100.99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 984.74,
    y: 100.99,
    width: 17.15,
    height: 64.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1027.68,140.34V125.85c0.26-9.52,3.17-10.46,12.09-10.46s12.08,0.94,12.08,10.46v14.49c0,9.6-3.17,10.55-12.08,10.55s-11.83-.95-12.09-10.55M1010,124.05v18.17c0,19.81,12.35,23.58,29.75,23.58s29.75-3.77,29.75-23.58V124.05c0-19.81-12.35-23.58-29.75-23.58S1010,104.25,1010,124.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1124.64 100.99 1125.66 150.37 1124.98 150.37 1106.55 100.99 1077.57 100.99 1077.57 165.29 1094.71 165.29 1093.68 115.91 1094.38 115.91 1112.55 165.29 1141.78 165.29 1141.78 100.99 1124.64 100.99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M688.92,211.58c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H688.84c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.06-18-16.8,0-27.18,1.2-27.18,19.64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -561.77,
    y: -1417.31,
    width: 4820.14,
    height: 3108.92
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "789.21 192.46 777.39 217.24 776.79 217.24 765.3 192.46 745.66 192.46 768.48 234.21 768.48 256.76 785.61 256.76 785.61 234.21 809.11 192.46 789.21 192.46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M811,211.58c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H810.9c0,21.09,10.89,21.43,27.27,21.43,28.29,0,27.86-10.46,27.86-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.85,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.06-18-16.81,0-27.18,1.2-27.18,19.64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "869.18 192.46 869.18 207.38 885.65 207.38 885.65 256.76 902.79 256.76 902.79 207.38 920.11 207.38 920.11 192.46 869.18 192.46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "925.58 192.46 925.58 256.76 972.57 256.76 972.57 242.7 942.73 242.7 942.73 230.19 970.17 230.19 970.17 218.26 942.73 218.26 942.73 206.52 971.97 206.52 971.97 192.46 925.58 192.46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1035.14 192.46 1023.49 232.84 1022.89 232.84 1010.63 192.46 983.45 192.46 983.45 256.76 1000.59 256.76 998.88 207.46 999.39 207.46 1015.86 256.76 1030.69 256.76 1046.97 207.46 1047.58 207.46 1045.86 256.76 1063.01 256.76 1063.01 192.46 1035.14 192.46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1071.4,211.58c0,18.43,9.25,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37h-16.46c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.07-18-16.8,0-27.17,1.2-27.17,19.64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,255.78a38.39,38.39,0,0,1-15.62-3.55v11.33H250.74c-2.2,0-5.67,1.67-5.67,3.87v31.26c0,2.2,3.46,3.18,5.67,3.18H355.56c2.2,0,5.45-.61,5.45-2.81V267.81c0-2.2-3.25-4.24-5.45-4.24H319.67V252.23A38.38,38.38,0,0,1,304,255.78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -382.9,
    y: -593.7,
    width: 2738.27,
    height: 1766.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.58,136.34a5.69,5.69,0,1,1,5.68,5.42,5.56,5.56,0,0,1-5.68-5.42m-8.78,0a14.47,14.47,0,1,0,14.47-14.94,14.73,14.73,0,0,0-14.47,14.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.15,136.34a5.69,5.69,0,1,1,5.68,5.42,5.56,5.56,0,0,1-5.68-5.42m-8.78,0a14.47,14.47,0,1,0,14.47-14.94,14.73,14.73,0,0,0-14.47,14.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.27,223.38c0-6.56,5.73-11.89,12.77-11.89s12.77,5.33,12.77,11.89-5.73,11.89-12.77,11.89-12.77-5.33-12.77-11.89m-16.41,0A29.18,29.18,0,1,0,303,194a29.29,29.29,0,0,0-29.18,29.33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.3,55.88H250.74c-2.2,0-5.67,1.52-5.67,3.72V90.86c0,2.2,3.46,3.33,5.67,3.33h37.69V194.53a36.17,36.17,0,0,1,31.25,0V94.19h35.89c2.2,0,5.45-.76,5.45-3V60c0-2.2-3.25-4.09-5.45-4.09H353.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.82,57.88V194.46L19.62,222.78c-0.13.15-.51,0.29-0.64,0.44-1.55,1.74-.82,4.53.84,6.16l26,22.68v44.85c0,2.12,1.28,4.16,3.41,4.16H79.35c2.12,0,2.72-2,2.72-4.16V214.78c10.66-13.25,24.08-26.5,35.9-39.76,1.46-1.64,3.14-3.27,4.6-4.9L128.1,164l20.43-22.85c0.34-.38.71-0.77,1.06-1.15l59.93-67.2c4.58-5.14,9.17-9.32,13.75-14.45,0.85-1,1.16-.37,1-2.5H171.74c-15.34,17.06-30.69,33.46-46,50.66-1.46,1.63-2.91,2.79-4.37,4.42l-3.19,3.33-18.09,20.17c-1.85,2.07-4.15,4.09-6,6.16-3.85,4.32-9.87,8.58-12,12.9V57.88c0-2.12-.94-2-3.07-2H48.27c-1.68,0-2.44.1-2.44,2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -378.47,
    y: -587.92,
    width: 2720.59,
    height: 1754.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.51,181.24l-14.8,16.6c-2.13,2.4-4.59,4.71-3.17,8.13,1,2.35,3.58,4,5.41,5.58l9.23,8.23L155.81,248l43.59,38.86c4.43,4,8.84,8.14,13.29,12.07,1.77,1.56,3.64,2.75,5.62,2.75h8.64a1.47,1.47,0,0,0,1-1.13s0.29-44.23.29-44.25a4.83,4.83,0,0,0-.32-1.75,3.58,3.58,0,0,0-.93-1.35l-0.17-.16-1.24-1.1L224,250.6l-1.27-1.13-0.52-.46c-2.34-1.92-4.56-4-6.81-6.06l-15.58-13.89L197.53,227l-31.6-28.14-15.66-14L142.56,178c-1.53-1.36-3-3.14-5.14-3.59a5.67,5.67,0,0,0-1.16-.12c-3.88,0-6.42,4.3-8.75,6.91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M684.42-392.63c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H684.33c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.61,0,9.61,6.6h16.46v-2.66c0-17.74-12-18-26.07-18-16.8,0-27.17,1.2-27.17,19.64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-16",
    x1: -72.18,
    y1: -467.06,
    x2: 4747.96,
    y2: -467.06,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M763-372.4v-14.49c0.26-9.52,3.17-10.46,12.09-10.46s12.08,0.94,12.08,10.46v14.49c0,9.6-3.17,10.55-12.08,10.55S763.28-362.8,763-372.4m-17.66-16.29v18.17c0,19.81,12.34,23.58,29.75,23.58s29.75-3.77,29.75-23.58v-18.17c0-19.81-12.35-23.58-29.75-23.58s-29.75,3.77-29.75,23.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "812.66 -411.75 812.66 -347.45 856.63 -347.45 856.63 -362.37 829.8 -362.37 829.8 -411.75 812.66 -411.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M901.46-411.75V-370c0,7.54-2.49,8.15-9.77,8.15s-11.32-.09-11.32-7.38v-42.52H863.22v42.86c0,15.44,2.75,21.95,28.47,21.95,18.86,0,26.92-4.8,26.92-21.95v-42.86H901.46Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "924 -411.75 924 -396.83 940.46 -396.83 940.46 -347.45 957.6 -347.45 957.6 -396.83 974.92 -396.83 974.92 -411.75 924 -411.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1023.18-372.4v-14.49c0.26-9.52,3.17-10.46,12.09-10.46s12.08,0.94,12.08,10.46v14.49c0,9.6-3.17,10.55-12.08,10.55s-11.83-.95-12.09-10.55m-17.66-16.29v18.17c0,19.81,12.35,23.58,29.75,23.58s29.75-3.77,29.75-23.58v-18.17c0-19.81-12.35-23.58-29.75-23.58s-29.75,3.77-29.75,23.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1120.13 -411.75 1121.16 -362.37 1120.47 -362.37 1102.04 -411.75 1073.06 -411.75 1073.06 -347.45 1090.21 -347.45 1089.18 -396.83 1089.87 -396.83 1108.04 -347.45 1137.27 -347.45 1137.27 -411.75 1120.13 -411.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M684.41-301.16c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H684.33c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.06-18-16.8,0-27.18,1.2-27.18,19.64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-30",
    x1: -566.28,
    y1: -375.59,
    x2: 4253.86,
    y2: -375.59,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "784.71 -320.28 772.88 -295.5 772.28 -295.5 760.79 -320.28 741.16 -320.28 763.97 -278.53 763.97 -255.98 781.11 -255.98 781.11 -278.53 804.61 -320.28 784.71 -320.28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M806.48-301.16c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H806.39c0,21.09,10.89,21.43,27.27,21.43,28.29,0,27.86-10.46,27.86-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.85,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.06-18-16.81,0-27.18,1.2-27.18,19.64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "864.68 -320.28 864.68 -305.37 881.14 -305.37 881.14 -255.98 898.28 -255.98 898.28 -305.37 915.6 -305.37 915.6 -320.28 864.68 -320.28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "921.08 -320.28 921.08 -255.98 968.06 -255.98 968.06 -270.04 938.23 -270.04 938.23 -282.56 965.66 -282.56 965.66 -294.48 938.23 -294.48 938.23 -306.22 967.46 -306.22 967.46 -320.28 921.08 -320.28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1030.64 -320.28 1018.98 -279.9 1018.38 -279.9 1006.12 -320.28 978.94 -320.28 978.94 -255.98 996.09 -255.98 994.37 -305.28 994.89 -305.28 1011.35 -255.98 1026.18 -255.98 1042.47 -305.28 1043.07 -305.28 1041.36 -255.98 1058.5 -255.98 1058.5 -320.28 1030.64 -320.28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1066.89-301.16c0,18.43,9.25,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H1066.8c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.07-18-16.8,0-27.17,1.2-27.17,19.64"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo blanco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 688.84,
    y: 100.48,
    width: 55.56,
    height: 65.33
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 749.87,
    y: 100.48,
    width: 59.5,
    height: 65.33
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 817.16,
    y: 100.99,
    width: 43.98,
    height: 64.3
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 867.73,
    y: 100.99,
    width: 55.39,
    height: 64.81
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 928.51,
    y: 100.99,
    width: 50.92,
    height: 64.3
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 984.74,
    y: 100.99,
    width: 17.14,
    height: 64.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1010.02,
    y: 100.48,
    width: 59.5,
    height: 65.33
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1077.57,
    y: 100.99,
    width: 64.21,
    height: 64.3
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 688.84,
    y: 191.95,
    width: 55.55,
    height: 65.33
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 745.67,
    y: 192.46,
    width: 63.44,
    height: 64.3
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 810.9,
    y: 191.95,
    width: 55.56,
    height: 65.33
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 869.19,
    y: 192.46,
    width: 50.92,
    height: 64.3
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 925.59,
    y: 192.46,
    width: 46.98,
    height: 64.3
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 983.45,
    y: 192.46,
    width: 79.56,
    height: 64.3
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1071.31,
    y: 191.95,
    width: 55.55,
    height: 65.33
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 245.07,
    y: 252.23,
    width: 115.94,
    height: 49.64
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 256.8,
    y: 121.4,
    width: 28.93,
    height: 29.88
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 322.37,
    y: 121.4,
    width: 28.93,
    height: 29.88
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 273.87,
    y: 194.04,
    width: 58.36,
    height: 58.67
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 245.07,
    y: 55.88,
    width: 115.94,
    height: 138.65
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 15.64,
    y: 55.27,
    width: 208.77,
    height: 246.4
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 108.11,
    y: 174.32,
    width: 120.08,
    height: 127.35
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M579,299.6h0l0-3.48V261.41a6.57,6.57,0,0,0-2.49-2c-1.83-1-3.51-2-5.3-3.13-3.53-2.13-6.91-4.38-10.41-6.57-5.36-3.35-10.71-6.65-16.09-10q-18.54-11.44-37.1-22.82l-8.36-5.15c-19.75-12.18-39.28-24.52-59.17-36.46-19.18-11.51-37.3-23.74-57-34.28a3,3,0,0,0-1.56-.49c-1.85,0-3.08,1.55-3.08,3.87v155c0,2.12.2,1.62,2.45,1.62h32c2.25,0,3.92.5,3.92-1.62V200.14L532,276.3,570,301.07h8.65a1.25,1.25,0,0,0,.36-0.23h0l0.05-.05V299.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M579.27,59.78A0.38,0.38,0,0,0,579,60C579.35,59.93,579.36,59.78,579.27,59.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M576.65,55.88h-23.7c-1.3,0-1.88.08-1.88,1.54v26h0.08V185.09l-142.85-86V57.42c0-1.63-.78-1.54-2.53-1.54H380.36c-1.39,0-2,.08-2,1.54V123.9l55.37,32.66c13.4,8.29,26.76,16.66,40.17,24.91q17.71,10.9,35.32,21.91h0l0.51,0.32q19.39,12.11,38.67,24.38l2.33,1.51,26.77,17.55c1.37-.56,1.37-2.1,1.37-3.76V83.45H579v-26C579,55.79,578.29,55.88,576.65,55.88Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 630.72,
    y: 43.14,
    width: 8.26,
    height: 271.47
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M684.42-392.63c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H684.33c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.61,0,9.61,6.6h16.46v-2.66c0-17.74-12-18-26.07-18-16.8,0-27.17,1.2-27.17,19.64"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -72.18,
    y: -2021.52,
    width: 4820.14,
    height: 3108.92
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M763-372.4v-14.49c0.26-9.52,3.17-10.46,12.09-10.46s12.08,0.94,12.08,10.46v14.49c0,9.6-3.17,10.55-12.08,10.55S763.28-362.8,763-372.4m-17.66-16.29v18.17c0,19.81,12.34,23.58,29.75,23.58s29.75-3.77,29.75-23.58v-18.17c0-19.81-12.35-23.58-29.75-23.58s-29.75,3.77-29.75,23.58"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -72.18,
    y: -2021.52,
    width: 4820.14,
    height: 3108.92
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "812.66 -411.75 812.66 -347.45 856.63 -347.45 856.63 -362.37 829.8 -362.37 829.8 -411.75 812.66 -411.75"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -72.18,
    y: -2021.52,
    width: 4820.14,
    height: 3108.92
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M901.46-411.75V-370c0,7.54-2.49,8.15-9.77,8.15s-11.32-.09-11.32-7.38v-42.52H863.22v42.86c0,15.44,2.75,21.95,28.47,21.95,18.86,0,26.92-4.8,26.92-21.95v-42.86H901.46Z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -72.18,
    y: -2021.52,
    width: 4820.14,
    height: 3108.92
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "924 -411.75 924 -396.83 940.46 -396.83 940.46 -347.45 957.6 -347.45 957.6 -396.83 974.92 -396.83 974.92 -411.75 924 -411.75"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -72.18,
    y: -2021.52,
    width: 4820.14,
    height: 3108.92
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1023.18-372.4v-14.49c0.26-9.52,3.17-10.46,12.09-10.46s12.08,0.94,12.08,10.46v14.49c0,9.6-3.17,10.55-12.08,10.55s-11.83-.95-12.09-10.55m-17.66-16.29v18.17c0,19.81,12.35,23.58,29.75,23.58s29.75-3.77,29.75-23.58v-18.17c0-19.81-12.35-23.58-29.75-23.58s-29.75,3.77-29.75,23.58"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -72.18,
    y: -2021.52,
    width: 4820.14,
    height: 3108.92
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1120.13 -411.75 1121.16 -362.37 1120.47 -362.37 1102.04 -411.75 1073.06 -411.75 1073.06 -347.45 1090.21 -347.45 1089.18 -396.83 1089.87 -396.83 1108.04 -347.45 1137.27 -347.45 1137.27 -411.75 1120.13 -411.75"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -72.18,
    y: -2021.52,
    width: 4820.14,
    height: 3108.92
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M684.41-301.16c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H684.33c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.06-18-16.8,0-27.18,1.2-27.18,19.64"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -566.28,
    y: -1930.05,
    width: 4820.14,
    height: 3108.92
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "784.71 -320.28 772.88 -295.5 772.28 -295.5 760.79 -320.28 741.16 -320.28 763.97 -278.53 763.97 -255.98 781.11 -255.98 781.11 -278.53 804.61 -320.28 784.71 -320.28"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -566.28,
    y: -1930.05,
    width: 4820.14,
    height: 3108.92
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M806.48-301.16c0,18.43,9.26,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H806.39c0,21.09,10.89,21.43,27.27,21.43,28.29,0,27.86-10.46,27.86-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.85,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.06-18-16.81,0-27.18,1.2-27.18,19.64"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -566.28,
    y: -1930.05,
    width: 4820.14,
    height: 3108.92
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "864.68 -320.28 864.68 -305.37 881.14 -305.37 881.14 -255.98 898.28 -255.98 898.28 -305.37 915.6 -305.37 915.6 -320.28 864.68 -320.28"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -566.28,
    y: -1930.05,
    width: 4820.14,
    height: 3108.92
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "921.08 -320.28 921.08 -255.98 968.06 -255.98 968.06 -270.04 938.23 -270.04 938.23 -282.56 965.66 -282.56 965.66 -294.48 938.23 -294.48 938.23 -306.22 967.46 -306.22 967.46 -320.28 921.08 -320.28"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -566.28,
    y: -1930.05,
    width: 4820.14,
    height: 3108.92
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1030.64 -320.28 1018.98 -279.9 1018.38 -279.9 1006.12 -320.28 978.94 -320.28 978.94 -255.98 996.09 -255.98 994.37 -305.28 994.89 -305.28 1011.35 -255.98 1026.18 -255.98 1042.47 -305.28 1043.07 -305.28 1041.36 -255.98 1058.5 -255.98 1058.5 -320.28 1030.64 -320.28"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -566.28,
    y: -1930.05,
    width: 4820.14,
    height: 3108.92
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1066.89-301.16c0,18.43,9.25,18.34,25.12,19.46l3.77,0.26c8.06,0.51,9,.42,9,6,0,5.4-2.66,5.92-10.72,5.92-8.4,0-10.8-.69-10.8-7.37H1066.8c0,21.09,10.89,21.43,27.26,21.43,28.29,0,27.87-10.46,27.87-21.09,0-14.74-4.72-17.14-23.75-18.51l-7.12-.51c-4.54-.35-7-0.51-7-5.66,0-3.6.77-5.49,10-5.49,6.86,0,9.6,0,9.6,6.6h16.46v-2.66c0-17.74-12-18-26.07-18-16.8,0-27.17,1.2-27.17,19.64"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -566.28,
    y: -1930.05,
    width: 4820.14,
    height: 3108.92
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinLogo);
export default __webpack_public_path__ + "static/media/kin-logo.716bf8cfcae246b4025eed86c7934f95.svg";
export { ForwardRef as ReactComponent };